import React, { useState } from "react";
import "./Navbar.css";
import { Link, useNavigate } from "react-router-dom";
import logo from "../resources/UIP-logo.png";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogin = () => {
    navigate("/login");
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-logo">
        <Link to="/" onClick={closeMenu}>
          <img alt="logo" src={logo} />
        </Link>
      </div>
      <button className="navbar-toggle" onClick={toggleMenu}>
        <span className="navbar-toggle-bar">&#9776;</span>
      </button>
      <div className={`navbar-links ${isMenuOpen ? "active" : ""}`}>
        <Link to="/" onClick={closeMenu}>
          Home
        </Link>
        <Link to="/about" onClick={closeMenu}>
          About Us
        </Link>
        <Link to="/services" onClick={closeMenu}>
          Services
        </Link>
        <Link to="/investor-education" onClick={closeMenu}>
          Investor Education
        </Link>
        {/* TODO: This doesn't remove the pages of blogs and warnings though,*/}
        {/* it just makes it inaccessable*/}

        {/* <Link to="/blog" onClick={closeMenu}> */}
        {/*   Blogs */}
        {/* </Link> */}
        {/* <Link to="/statutory-warning" onClick={closeMenu}> */}
        {/*   Statutory Warnings */}
        {/* </Link> */}
        <Link to="/contact" onClick={closeMenu}>
          Contact Us
        </Link>
      </div>
      <div className="navbar-login">
        <button
          className="button"
          onClick={() => {
            closeMenu();
            handleLogin();
          }}
        >
          <span>Login</span>
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
